import { type RefObject, useEffect, useState } from 'react'

import { useWindowSize } from 'commons/customHooks/useWindowSize'
import type { WidthMenuProps } from 'components'

export function useElementPosition(elementRef: RefObject<HTMLElement | null>): WidthMenuProps {
  const [windowWidth] = useWindowSize()
  const [elementPosition, setElementPosition] = useState<WidthMenuProps>({} as WidthMenuProps)

  useEffect(() => {
    if (elementRef.current) {
      const rightEdge = elementRef.current?.getBoundingClientRect().right
      const leftEdge = elementRef.current?.getBoundingClientRect().left
      const endPosition = rightEdge - leftEdge
      setElementPosition({
        endPosition: endPosition,
        startPosition: leftEdge,
      })
    }
  }, [elementRef, windowWidth])

  return elementPosition
}
